import React from 'react'
import Wprr from 'wprr'

export default class Header extends Wprr.BaseObject {

    _construct() {
        super._construct();
        this._elementTreeItem.requireValue("open", false);
    }

    _toogleOpen() {
        this._elementTreeItem.setValue("open", !this._elementTreeItem.getValue("open"));
    }

    _renderMainElement() {

        let mobileLayout = <div className="header-background">
            <div className="centered-site">
				<div className="spacing medium" />
                <Wprr.FlexRow className="big-item-spacing vertically-center-items justify-between" itemClasses="flex-no-resize,flex-no-resize">
                   <Wprr.Link href={Wprr.sourceReference("wprr/paths/home")} className="custom-styled-link">
                        <Wprr.FlexRow className="micro-item-spacing vertically-center-items">
                            <Wprr.Image src="logo.png" className="image background-contain header-logo small" />
                            <div className="header-site-name">Whiston Farm Storage</div>
                        </Wprr.FlexRow>
                        
                    </Wprr.Link>
                    <Wprr.CommandButton  commands={Wprr.commands.callFunction(this, this._toogleOpen)}>
                        <div className="header-menu-link">Menu</div>
                    </Wprr.CommandButton>
                </Wprr.FlexRow>
				<Wprr.OpenCloseExpandableArea open={this._elementTreeItem.getValueSource("open")}>
                    <div className="spacing medium" />
                    <div>
                        <Wprr.FlexRow className="line mobile-menu-divider" />
                        <Wprr.layout.wordpress.Menu location="top-menu_default">
                            <div>
                                
                                    <Wprr.Adjust adjust={Wprr.adjusts.isUrlAtPath(Wprr.sourceReference("item", "url"), null, {"not": "not-active", "at": "active", "in": "child-active"}, "className")}>
                                        <Wprr.Link href={Wprr.sourceReference("item", "url")} className="custom-styled-link">
                                            <div className="spacing small" />
                                            <div className="header-menu-link">{Wprr.text(Wprr.sourceReference("item", "label"))}</div>
                                            <div className="spacing small" />
                                        </Wprr.Link>
                                    </Wprr.Adjust>
                            </div>
                            <Wprr.FlexRow data-slot="spacing" className="line mobile-menu-divider" />
                        </Wprr.layout.wordpress.Menu>
                        <Wprr.FlexRow className="line mobile-menu-divider" /> 
                    </div>    
                </Wprr.OpenCloseExpandableArea>	
				<div className="spacing medium" />
            </div>
        </div>;
        
        
        let desktopLayout = <div className="header-background">
            <div className="centered-site">
				<div className="spacing medium" />
                <Wprr.FlexRow className="micro-item-spacing vertically-center-items" itemClasses="flex-no-resize,flex-resize">
                    
                    <Wprr.Link href={Wprr.sourceReference("wprr/paths/home")} className="custom-styled-link">
                        <Wprr.FlexRow className="micro-item-spacing vertically-center-items">
                            <Wprr.Image src="logo.png" className="image background-contain header-logo small" />
                            <div className="header-site-name">Whiston Farm Storage</div>
                        </Wprr.FlexRow>
                        
                    </Wprr.Link>
                    <div>
                        <Wprr.FlexRow className="small-item-spacing vertically-center-items" itemClasses="flex-resize,flex-no-resize,flex-no-resize">
                            <div />
                            <div>
                                <Wprr.layout.wordpress.Menu location="top-menu_default">
                                    <Wprr.Adjust adjust={Wprr.adjusts.isUrlAtPath(Wprr.sourceReference("item", "url"), null, {"not": "not-active", "at": "active", "in": "child-active"}, "className")}>
                                        <Wprr.Link href={Wprr.sourceReference("item", "url")} className="custom-styled-link">
                                            <div className="header-menu-link">{Wprr.text(Wprr.sourceReference("item", "label"))}</div>
                                        </Wprr.Link>
                                    </Wprr.Adjust>
                                    <Wprr.FlexRow data-slot="insertElements" className="medium-item-spacing" />
                                </Wprr.layout.wordpress.Menu>
                            </div>
                            <div>
                                <Wprr.Link href="/request-a-quote/" className="custom-styled-link">
                                    <Wprr.layout.interaction.Button className="standard-button standard-button-hover standard-button-padding cursor-pointer text-align-center" text="Request a quote" />
                                </Wprr.Link>
                            </div>
                        </Wprr.FlexRow>
                    </div>
                </Wprr.FlexRow>
						
				<div className="spacing medium" />
            </div>
        </div>;
        
        let responsiveLayout = Wprr.creators.responsiveTemplate(mobileLayout);
        responsiveLayout.addResponsiveTemplate(desktopLayout, 860);
        
        return <React.Fragment>
            {responsiveLayout.getReactElements()}
        </React.Fragment>;

        return 
    }
}
